<template>
  <validation-observer ref="observer" v-slot="{ passes }" slim>
    <b-modal
      v-bind="$attrs"
      v-model="dialog"
      :hide-header-close="saving"
      @ok.prevent="cancelOnly ? close() : passes(save)"
      @close.prevent="close"
      @cancel.prevent="close"
      :no-close-on-esc="saving"
      :no-close-on-backdrop="saving"
      @show="onShow"
    >
      <slot :editedItem="editedItem"></slot>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          v-if="!preparedOkOnly"
          :variant="cancelVariant"
          :disabled="saving"
          @click.prevent="cancel"
        >
          {{ preparedCancelTitle }}
        </b-button>
        <base-btn :variant="preparedOkVariant" :loading="saving" @click="ok">
          {{ preparedOkTitle }}
        </base-btn>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import { dialogMixin } from "@foys-tech/foys-utils";
import { BaseBtn } from "@foys-tech/foys-base-components";
export default {
  mixins: [dialogMixin],
  components: { BaseBtn },
  props: {
    saving: {
      type: Boolean,
      default: false,
    },
    okTitle: {
      type: String,
      default: null,
    },
    okVariant: {
      type: String,
      default: "primary",
    },
    okOnly: {
      type: Boolean,
      default: false,
    },
    cancelTitle: {
      type: String,
      default: null,
    },
    cancelVariant: {
      type: String,
      default: "secondary",
    },
    cancelOnly: {
      type: Boolean,
      default: false,
    },
    loadReferencesFn: {
      type: Function,
      default: null,
    },
  },
  computed: {
    preparedOkOnly() {
      return this.okOnly || this.cancelOnly;
    },
    preparedOkTitle() {
      return this.cancelOnly
        ? this.cancelTitle || this.$t("common.close")
        : this.okTitle || this.$t("common.save");
    },
    preparedOkVariant() {
      return this.cancelOnly ? this.cancelVariant : this.okVariant;
    },
    preparedCancelTitle() {
      return this.cancelTitle || this.$t("common.close");
    },
  },
};
</script>